<app-header-landing></app-header-landing>
<div style="width: 100%;">
    <div class="content-wrapper">
        <div class="page-header">
            <h3 class="page-titles" style="cursor:context-menu;">
                <span class="page-title-icons bg-gradient-primary text-white mr-2">
                    <i class="mdi mdi-book-open-page-variant menu-icon"></i>
                </span> ข้อมูลหน่วยงาน
            </h3>
        </div>
        <div class="row">
            <div class="col-12 grid-margin">
                <div class="card" style="border-radius: 15px;" >

                    <div class="card-body" style="min-height: 70vh;">
                        <div class="row">
                            <div class="col-3">
                                <ul class="nav nav-pills nav-pills-vertical nav-pills-primary" id="v-pills-tab"
                                    role="tablist" aria-orientation="vertical">
                                    <li class="nav-item" *ngFor="let type of types; let index=index">
                                        <a class="nav-link" id="v-pills-{{index}}-tab" data-toggle="pill"
                                            [attr.href]="'#tab'+index" role="tab" aria-selected="true"
                                            [ngClass]="{'active': index == 0}" (click)="displayPdf = false">
                                            <i class="mdi mdi-bookmark-outline"></i> {{type}} </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-9">
                                <div class="tab-content tab-content-vertical" id="v-pills-tabContent">
                                    <div class="tab-pane fade show active" *ngFor="let type of types; let index=index"
                                        id="tab{{index}}" role="tabpanel" style="min-height: 60vh;"
                                        [ngClass]="{'active': index == 0}">
                                        <div class="table-responsive" *ngIf="!displayPdf">
                                            <table class="table table-striped" style="cursor:context-menu;">
                                                <colgroup>
                                                    <col style="width: 5%; text-align: center;">
                                                    <col style="width: 95%;">
                                                </colgroup>
                                                <tbody>
                                                    <tr *ngFor="let file of data_internal[index]" style="cursor: pointer;">
                                                        <td><i class="mdi mdi-file-document"></i></td>
                                                        <td>{{file.pdf_name}}</td>
                                                        <td><button type="button"
                                                                class="btn btn-inverse-danger btn-icon btn-sm"
                                                                (click)="onClickView(file.pdf_file, file.pdf_name)">
                                                                <i class="mdi mdi-eye"></i>
                                                            </button>
                                                            <button type="button"
                                                                class="btn btn-inverse-primary btn-icon btn-sm"
                                                                style="margin-left: 10px;"
                                                                (click)="onClickDownload(file.pdf_file, file.pdf_name)">
                                                                <i class="mdi mdi-download"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div *ngIf="displayPdf">
                                            <div class="row">
                                                <div class="col-6 text-left" style="cursor:context-menu;">{{pdfName}}</div>
                                                <div class="col-6 text-right"><button type="button" class="btn btn-outline-primary"
                                                        (click)="onClickClose()">ย้อนกลับ</button></div>
                                            </div><br>
                                            <pdf-viewer [original-size]="false" [src]="pdfView" [render-text]="true" style="display: block;"></pdf-viewer>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <footer class="footer" style="padding-top: 10px; padding-bottom: 10px;">
        <div class="d-sm-flex justify-content-center justify-content-sm-between">
            <span class="text-muted text-center text-sm-left d-block d-sm-inline-block"
                style="margin-top: auto; margin-bottom: 0px;">Copyright © 2023 <a href="https://www.mapedia.co.th/"
                    target="_blank">MAPEDIA . co . th</a>. All rights
                reserved.</span>
            <div class="text-right">
                <div class="text-right" style="margin-right: 3px;">จำนวนผู้เข้าชมเว็บไซต์</div>
                <div class="text-right">
                    <span class="count-visitor" *ngFor="let i of visitor">{{i}}</span>
                </div>
            </div>
        </div>
    </footer>